import {DestroyRef, inject} from '@angular/core';
import {ViewContextService} from './view-context.service';
import {ViewContextEntity} from './view-context.models';

/**
 * One-line registration helper for a page's view context. Must be called from an
 * injection context (a component constructor or field initializer) — it registers on
 * call and automatically unregisters on the component's destruction via `DestroyRef`.
 *
 * `getEntities` is called fresh on every dialog turn, so it can safely close over plain
 * (non-signal) component fields that change over time.
 */
export function provideViewContext(route: string, getEntities: () => ViewContextEntity[]): void {
  const service = inject(ViewContextService);
  const destroyRef = inject(DestroyRef);

  const id = service.register(route, getEntities);
  destroyRef.onDestroy(() => service.unregister(id));
}
